// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__nYVYh","bigColWidth":"Table_bigColWidth__1MZJq","biggerColWidth":"Table_biggerColWidth__2wYp1","row":"Table_row__18PWK","col":"Table_col__P8jb9"};